import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';

import styles from '../Healthboard/Components/AppointmentDetailsPopup/styles.styl';
import { useOTScriptLoad } from '../../redux/opentok/hooks/useOTScriptLoad';
import BackButton from '../common/BackButton';
import TestDetails from './TestDetails';
import Loader from '../common/Loader';
import Popup from '../common/Popup';
import { enhance } from './enhance';

function VirtualVideoTest({
  onClose,
  pending,
  loggedUserId,
  getCredentials,
  testCredentials,
  visitTestPerformed,
  onStartVideoVisit,
  virtualCallEnabled,
  intl: { formatMessage },
}) {
  const { loaded } = useOTScriptLoad(true);

  useEffect(() => {
    getCredentials({ id: loggedUserId });
  }, [loggedUserId]);

  return (
    <Popup
      opened
      strictClose
      contentNoPadding
      onClose={onClose}
      withHeading={false}
      disableFillBackground
      mobileFullScreen={false}
      overflowVisible
    >
      <div className={styles.root}>
        <div className={styles.content}>
          <div className={styles.coverHeader} onClick={onClose} />
          <BackButton
            onBack={onClose}
            className={styles.backButton}
            minWidth={0}
          />
          {!loaded || pending ? (
            <Loader />
          ) : (
            <TestDetails
              onClose={onClose}
              formatMessage={formatMessage}
              testCredentials={testCredentials}
              onStartVideoVisit={onStartVideoVisit}
              virtualCallEnabled={virtualCallEnabled}
              visitTestPerformed={visitTestPerformed}
            />
          )}
        </div>
      </div>
    </Popup>
  );
}

VirtualVideoTest.propTypes = {
  intl: PropTypes.object,
  onClose: PropTypes.func,
  onStartVideoVisit: PropTypes.func,
  virtualCallEnabled: PropTypes.bool,
  pending: PropTypes.bool,
  testCredentials: PropTypes.object,
  loggedUserId: PropTypes.number,
  getCredentials: PropTypes.func,
  visitTestPerformed: PropTypes.bool,
};

export default enhance(VirtualVideoTest);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/index.jsx